const verify_account = {
    title: String("Verificació de l'usuari"),
};

export default verify_account;